/* 
 * To change this template, choose Tools | Templates
 * and open the template in the editor.
 */


$(function() {

   

    $(document).on('click', '.addSearchTerm', function(e) {
        //alert('name');
        var name = $(this).attr("data-text")+'.';
        $("#inputString").val( $.trim( name));
        var queryString = 'queryString='+name;
        //besser zusammenfassen zu einer Abfrage!
        
        pathname = $('head base').attr('href')+"b2b/ajaxSearchState";
        $.post( pathname , queryString, function( data ) {  
            $('#suggestions').fadeOut(); // Show the suggestions box
            $('#suggestionsCountryState').fadeIn();
            $('#suggestionsCountryState').html(data); // Fill the suggestions box
            $("#inputString").focus();
        });
        return false;
    });
    
    
    /**
    * Löscht den Suchterm innerhalb der Suchleiste
    */
    $(document).on('click', '.removeSearchTerm', function(e) {
        $("#inputString").val("");
        $('#suggestions').fadeOut(); // Show the suggestions box
        $('#suggestionsCountryState').fadeOut();
        $("#inputString").focus();
        return false;
    });
    
    
    $(document).on('click', '.appendSearchTop', function(e) {
        //alert('name');
        var name = $(this).attr("data-text");
        var inputStringBefore = $.trim($("#inputString").val());
        //ermittle alle Stellen nach dem ersten Punkt
        var arrayOfStrings  = inputStringBefore.split('.');
        
        for (var i=0; i < arrayOfStrings.length; i++){
            arrayOfStrings[i] = $.trim(arrayOfStrings[i]);
        }
        
        var newValue = arrayOfStrings[0] +"." + $.trim( name);
        $("#inputString").val(newValue);
        var queryString = 'queryString='+newValue;
        //besser zusammenfassen zu einer Abfrage!
        
        pathname = $('head base').attr('href')+"b2b/ajaxSearch";
        $.post( pathname , queryString, function( data ) {  
            $('#suggestionsCountryState').fadeOut();
            $('#suggestions').fadeIn(); // Show the suggestions box
            $('#suggestions').html(data); // Fill the suggestions box
        });
        
        return false;
    });
    
    
    
    $(document).on('click', '.setSearchTerm', function(e) {
        $("#inputString").val($(this).children().text());
        $("#inputString").focus().val($(this).children().text()); //BUGFIX : http://stackoverflow.com/questions/1056359/set-mouse-focus-and-move-cursor-to-end-of-input-using-jquery
        return false;
    });


    /**
     * Menü (oben) , wenn ein Element geklickt wird, müssen andere Menüeinträge wieder verschwinden
     * gegenseitig ausblenden!
     **/
    $('.linkLogin').bind('click', function(e) {
        e.preventDefault();
        $( "#registerWindow" ).slideUp();
        /*
        if ($("#menuWindow").is(':visible')){
             $( "#menuWindow" ).slideToggle( "slow", function() {});
        }*/  
        $( "#menuWindow" ).slideUp();
        $( "#userWindow" ).slideUp(); 
        $( "#loginWindow" ).slideToggle( "slow", function() {});
    });
    $('.linkRegister').bind('click', function(e) {
        e.preventDefault();
        $("#loginWindow").slideUp();
        $("#menuWindow").slideUp();
        $("#userWindow").slideUp();
        $( "#registerWindow" ).slideToggle( "slow", function() { });
    });
    $('.linkMenu').bind('click', function(e) {
        e.preventDefault();
        $("#loginWindow").slideUp();
        $("#registerWindow").slideUp();
        $("#userWindow").slideUp();
        $( "#menuWindow" ).slideToggle( "slow", function() { });
    });
    $('.linkUser').bind('click', function(e) {
        e.preventDefault();
        $("#loginWindow").slideUp();
        $("#registerWindow").slideUp();
        $("#menuWindow").slideUp();
        $( "#userWindow" ).slideToggle( "slow", function() { });
    });
    
    
    
    
  
    
    /**
     * Zusätzliche Branche
     */
    $('.linkBrancheExtra').bind('click', function(e) {
        e.preventDefault();
        $( ".addOn" ).slideToggle( "slow", function() {
            });
    });
    
    $('.toggle').bind('click', function(e) {
        e.preventDefault();
        
        $( ".addOn" ).slideToggle( "slow", function() { });
    });
    
    $('.linkOptions').bind('click', function(e) {
        e.preventDefault();
        if( $( ".optionWindow" )){
        $( ".optionWindow" ).slideToggle( "slow", function() {
            });
        }
    });
   
   /*
    if($("img")){
    $("img").tooltip({
        'selector': '',
        'placement': 'right'
    });
	}*/
    
    
    
    $('.toggleContent').bind('click' ,function(e) {
       e.preventDefault();
       var target = $(this).attr("data-target");
        $( target ).slideToggle( "slow", function() {
        });
        if(target == '#moreGMap'){
            if(slideCnt==0){
            resetMap(map)
        }
        slideCnt++;
        }
    });
    
   // $('#basicBookmark').bookmark({sites:['facebook', 'google', 'twitter', 'xing', 'blogger','tumblr', 'yahoo' ]});
// $(".video").fitVids();
   
}); 
         
          